import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {ClientMelding} from '../client-melding';
import {DialogService} from '../../core/dialog/dialog.service';
import {filter} from 'rxjs/operators';
import User, {Role} from '../../core/auth/user';

@Component({
    selector: 'zah-client-meldingen',
    templateUrl: './client-meldingen.component.html',
    styleUrls: ['./client-meldingen.component.scss'],
    standalone: false
})
export class ClientMeldingenComponent {
  private dialogService = inject(DialogService);

  @Input()
  clientMeldingen: Array<ClientMelding>;
  @Input()
  user: User;
  @Output()
  clientMeldingAdded: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  clientMeldingEdited: EventEmitter<[ClientMelding, string]> = new EventEmitter<[ClientMelding, string]>();
  @Output()
  clientMeldingDeleted: EventEmitter<ClientMelding> = new EventEmitter<ClientMelding>();

  getClientMeldingId(index: number, clientMelding: ClientMelding): string {
    return clientMelding.getId();
  }

  onMeldingClick(clientMelding: ClientMelding): void {
    if (this.user.hasRole(Role.REGIOVERANTWOORDELIJKE)) {
      this.dialogService.showInformation(clientMelding.getContent(),
        [
          {toUrl: `clienten/${clientMelding.getClientId()}`, label: 'Naar Cliënt'},
          {toUrl: `clienten/${clientMelding.getClientId()}/fiche/beheer`, label: 'Naar Cliëntfiche'}
        ]);
    } else {
      this.dialogService.showInformation(clientMelding.getContent())
    }
  }

  onEditClick(clientMelding: ClientMelding): void {
    this.dialogService
      .askText({
        label: 'Melding wijzigen',
        placeholder: 'Wijzig melding',
        text: clientMelding.getContent(),
        confirmLabel: 'Wijzigen',
      })
      .subscribe(content => this.clientMeldingEdited.emit([clientMelding, content]));
  }

  onDeleteClick(clientMelding: ClientMelding): void {
    this.dialogService
      .askConfirmation({message: 'Ben je zeker dat je de melding wil verwijderen?'})
      .pipe(filter(confirmation => confirmation))
      .subscribe(() => this.clientMeldingDeleted.emit(clientMelding));
  }

  onAddClick(): void {
    this.dialogService
      .askText({
        label: 'Nieuwe melding',
        placeholder: 'Voer een nieuwe melding in',
        confirmLabel: 'Bewaar',
      })
      .subscribe(melding => this.clientMeldingAdded.emit(melding));
  }
}
